import { JSONPath } from 'jsonpath-plus';
import { groupBy, partition } from 'lodash';
import { detectDuplicates } from '../helper-functions';
import { byBuildOrder, containingDeclaration, declaredIdPaths, declaredInterfaceIdPaths, exclusiveGroup, isAlternative } from './declaration-paths';
/**
 * The rule blames the second declaration it sees, but one query per declaration site means
 * matches arrive grouped by site rather than by position.
 */
function inBuildOrder(matches) {
    return [...matches].sort((left, right) => byBuildOrder(left.pointer, right.pointer));
}
function groupMatches(matches, key) {
    return Object.values(groupBy(matches, match => key(match.pointer)));
}
/**
 * A relationship names an interface beside its node, so an interface id only has to be
 * unique among the nodes that can appear in one architecture. At most one alternative of a
 * prefixItems entry is ever chosen, so alternatives may repeat an interface id.
 */
function detectDuplicateInterfaceIds(matches, seenIds, messages) {
    for (const group of groupMatches(matches, exclusiveGroup)) {
        const [choices, fixed] = partition(group, match => isAlternative(match.pointer));
        detectDuplicates(fixed, seenIds, messages);
        groupMatches(choices, containingDeclaration).forEach(choice => detectDuplicates(choice, new Set(seenIds), messages));
        choices.forEach(match => seenIds.add(match.value));
    }
}
/**
 * Reports any unique-id a pattern declares more than once.
 */
export default (input, _, context) => {
    if (!input) {
        return [];
    }
    const collect = (paths) => inBuildOrder(paths.flatMap(path => JSONPath({ path, json: context.document.data, resultType: 'all' })));
    const nodeIdMatches = collect(declaredIdPaths('nodes'));
    const relationshipIdMatches = collect(declaredIdPaths('relationships'));
    const interfaceIdMatches = collect(declaredInterfaceIdPaths());
    const seenIds = new Set();
    const messages = [];
    detectDuplicates(nodeIdMatches, seenIds, messages);
    detectDuplicates(relationshipIdMatches, seenIds, messages);
    detectDuplicateInterfaceIds(interfaceIdMatches, seenIds, messages);
    return messages;
};
//# sourceMappingURL=ids-are-unique.js.map